import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {take} from 'rxjs/operators';
import {ApiUrlService} from "./api-url.service";
import {LoggingEntry} from "../../model/logging/logging-entry";

@Injectable({
    providedIn: 'root' // ✅ Ensures the service is available globally
})
export class LoggingApiService {

    private http = inject(HttpClient);
    private apiUrlService = inject(ApiUrlService);

    sendLogEvent(loggingData: LoggingEntry): void {
        this.http
            .post<string>(`${this.apiUrlService.getApiUrl()}/log`, loggingData)
            .pipe(take(1))
            .subscribe({
                next: () => {},
                error: (error) => {
                 // TODO: enable   if (!environment.production) {
                        console.log(error);
                 //   }
                }
            });
    }
}